export default __webpack_public_path__ + "static/media/eye.a67d1083.svg";